<template>
  <div ref="main">
    <div id="header">
      <b-row align-v="center">
        <b-col cols="8" class="text-left mt-3 ml-3">
          <div class="current-file" v-if="files.length">
            <span class="fileNumber current-fileNumber"
              >{{ currentFile }} / {{ files.length }}</span
            >
            <span>{{ files[currentFile - 1].document.name }}</span>
          </div>
        </b-col>

        <b-col class="text-right mr-3">
          <a :href="url" :download="download">
            <b-icon
              id="tooltip-download"
              icon="download"
              style="cursor: pointer"
              class="mt-3 mb-0 h4"
            />
            <b-tooltip target="tooltip-download" variant="light" triggers="hover">
              Télécharger
            </b-tooltip>
          </a>
        </b-col>
      </b-row>

      <hr />
    </div>
    <div style="margin-top: 95px">
      <div
        class="shadow mx-auto mb-3"
        v-bind:style="{
          width: zoom,
        }"
        v-for="i in pageCount"
        :key="i"
      >
        <pdf :src="src" :page="i"></pdf>
      </div>
      <div class="p-3">
        <b-button
          variant="primary"
          class="btn-spin"
          @click="confirmOwnership"
          v-if="!isLoading"
          >{{ !isSigning ? 'Signer' : '' }}<b-spinner :hidden="!isSigning" small></b-spinner></b-button
        >
      </div>
      <div>
        <b-modal
          id="modal-1"
          title="Code de validation"
          v-model="show"
          centered
          no-close-on-esc
          no-close-on-backdrop
          hide-header-close
        >
          <div>
            <p v-if="profile === 'PADES_SEAL_EMAIL'">
              Saisissez le code transmis par email et validez :
            </p>
            <p v-if="profile === 'PADES_SEAL_SMS'">
              Saisissez le code transmis par SMS et validez :
            </p>
            <b-form-input
              ref="code"
              autocomplete="off"
              id="code-input"
              placeholder="Code"
              type="tel"
              v-model="code"
              :formatter="formatCode"
              autofocus
              :state="state"
            ></b-form-input>
            <b-form-invalid-feedback id="code-input">{{
              errorMsg
            }}</b-form-invalid-feedback>
            <div class="pt-3">
              <b-button variant="outline-primary" @click="sendCode"
                >Envoyez moi un nouveau code</b-button
              >
            </div>
          </div>
          <template v-slot:modal-footer
            ><div class="w-100">
              <b-button
                class="float-right ml-3 btn-spin"
                variant="primary"
                @click="applyCode"
                :disabled="String(code).length < 7"
                >{{ !isConfirming ? 'Valider' : '' }}<b-spinner :hidden="!isConfirming" small></b-spinner></b-button
              >
              <b-button
                class="float-right"
                variant="secondary"
                @click="show = false, isSigning = false"
                >Annuler</b-button
              >
            </div>
          </template>
        </b-modal>
      </div>
      <div id="pluswrap" v-if="isLoading">
        <div class="plus flex-column align-items-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
          En cours de chargement...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import { download } from "../services/document.service";
import { get, sendCode, applyCode } from "../services/signature.service";
import { mapState, mapActions } from "vuex";

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
}

export default {
  name: "App",
  components: {
    pdf,
  },
  data() {
    return {
      isLoading: true,
      src: undefined,
      pageCount: undefined,
      currentFile: undefined,
      fileCount: undefined,
      files: [],
      signIdx: undefined,
      profile: undefined,
      code: "",
      show: false,
      state: undefined,
      errorMsg: undefined,
      isConfirming: false,
      isSigning: false,
      zoom: "96%",
    };
  },

  computed: {
    ...mapState(["signatures", "token"]),
    url: function() {
      return `https://${document.location.hostname}/pdf/${this.signatures[this.signIdx].document.id}/file?token=${this.token}`
    },
    download: function() {
      return this.signatures[this.signIdx].document.name
    }
  },

  methods: {
    ...mapActions(["updateToken", "updateSignatures"]),

    formatCode(val) {
      let code = val.replace(/ /g, "");
      let matches = code.match(/^[0-9]+$/);
      if (matches == null)
        // prohibits any character other than digit
        return String(val).substring(0, String(val).length - 1);
      else if (String(code).length <= 3) return String(code);
      else if (String(code).length > 3 && String(code).length < 7)
        return (
          String(code).substring(0, 3) +
          " " +
          String(code).substring(3, String(code).length + 1)
        );
      else
        return (
          String(code).substring(0, 3) + " " + String(code).substring(3, 6)
        );
    },
    confirmOwnership() {
      this.isSigning = true;
      if (this.profile === 'PADES_SEAL_EMAIL' || this.profile === 'PADES_SEAL_SMS') {
        this.sendCode().then(() => this.show = true)
      }
      else {
        this.applyCode() // Apply a no-code
      }
    },
    sendCode() {
      return sendCode(
        `${this.signatures[this.signIdx].id}`,
        this.profile.split('_')[2],
        this.token
      );
    },
    applyCode() {
      this.isConfirming = true;
      applyCode(
        `${this.signatures[this.signIdx].id}`,
        this.code.replace(/ /g, ""),
        this.$route.query.urlcallback,
        this.token
      )
      .then(() => {
        if (this.currentFile < this.fileCount) {
          this.show = false;
          this.currentFile++;
          this.signIdx++;
          this.fileName = this.signatures[this.signIdx].document.name;
          this.code = "";

          this.isLoading = true;
          this.isConfirming = false;
          this.isSigning = false;

          download(
            `${this.signatures[this.signIdx].document.id}`,
            this.token
          ).then((response) => {
            var blob = new Blob([response.data], {
              type: "application/pdf",
            });
            var blobURL = window.URL.createObjectURL(blob);
            this.src = pdf.createLoadingTask(blobURL);
            this.src.promise.then((pdf) => {
              this.pageCount = pdf.numPages;
              this.isLoading = false;

              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0; // For Safari browser
            });
          });
        } else {
          if (this.$route.query.urlsuccess) {
            window.top.location.href = this.$route.query.urlsuccess;
          } else {
            this.$router.push("/ack");
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          this.isConfirming = false;
          if (error.response.status === 400) {
            this.errorMsg = "Le code saisi est incorrect";
            this.$refs.code.focus();
          } else {
            this.errorMsg =
              "Erreur technique, merci de réessayer ultérieurement";
          }
          this.state = false;
        }
      });
    },
    downloadFile() {
      download(`${this.signatures[this.signIdx].document.id}`, this.token).then(
        (response) => {
          var blob = new Blob([response.data], { type: "application/pdf" });
          var blobURL = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobURL;
          link.setAttribute(
            "download",
            `${this.signatures[this.signIdx].document.name}`
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
      );
    },
  },
  watch: {
    code: function () {
      if (String(this.code).length < 7) {
        this.state = null;
      }
    },
  },
  created() {
    this.updateToken(this.$route.params.token);

    if (!isMobile()) {
      this.zoom = this.$route.query.zoom
        ? this.$route.query.zoom + "%"
        : "94% ";
    }

    get(this.token)
      .then((response) => {
        this.updateSignatures(response.data);
        this.fileCount = response.data.length;
        this.currentFile = 1;
        this.signIdx = 0;
        this.files = this.signatures;
        this.profile = response.data[0].profileCode;

        download(
          `${this.signatures[this.signIdx].document.id}`,
          this.token
        ).then((response) => {
          var blob = new Blob([response.data], { type: "application/pdf" });
          var blobURL = window.URL.createObjectURL(blob);
          this.src = pdf.createLoadingTask(blobURL);
          this.src.promise.then((pdf) => {
            this.pageCount = pdf.numPages;
            this.isLoading = false;
          });
        });
      })
      .catch(() => {
        this.$router.push("/404");
      });
  },
};
</script>

<style>
.modal-backdrop {
  opacity: 0.5 !important;
}
#pluswrap {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  top: 0;
}
.plus {
  display: flex;
  margin: 0 auto;
}
#header {
  background-color: white;
  position: fixed;
  top: 0;
  width: 100%;
  text-align: center;
  font-size: 14px;
  z-index: 1;
}

.current-file {
  color: #2c3e50;
  font-size: 16px;
  margin: 10px;
}
.other-file {
  margin: 10px;
  font-size: 12px;
  color: #d5d4d4;
}
.fileNumber {
  color: #fff;
  margin-right: 5px;
  border-radius: 2px;
}

.current-fileNumber {
  background-color: #005bbd;
  padding: 7px 10px;
}

.other-fileNumber {
  background-color: #d5d4d4;
  padding: 5px 8px;
}
.bi-download {
  color: #005bbd;
}

.btn {
  border-radius: 2px;
}
.btn-primary {
  background-color: #005bbd;
}
.btn-outline-primary {
  color: #005bbd;
  border-color: #005bbd;
}
.btn-spin {
  width: 73px
}

.modal {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  overflow: hidden;
  outline: 0;
  height: auto !important;
  top: auto !important;
}
</style>
